export default ({ className }) => {
  return (
    <svg
      class={className}
      id="Capa_1"
      enable-background="new 0 0 280.823 280.823"
      viewBox="0 0 280.823 280.823"
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
    >
      <path d="m250.734 40.137-90.265-.02v20.059h90.265c5.534 0 10.029 4.515 10.029 10.049v80.216c0 5.534-4.496 10.029-10.029 10.029h-212.34l45.877-45.877-14.182-14.182-70.089 70.088 70.206 70.206 14.182-14.182-45.994-45.994h212.341c16.592 0 30.088-13.497 30.088-30.088v-80.216c0-16.592-13.497-30.088-30.089-30.088z" />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./components/icon/SubmitIcon.js